<template>
  <div>
    <div v-if="bIsLoading">Загружаем данные...</div>
    <card v-else>
        <h4>Задайте общие настройки</h4>
        <button class="btn btn-simple btn-primary" @click="Return()">Назад</button>
        <ReFormPrinter :masFormConfig="masAllFormParams" :objSaveApiMethod="currentApiFormMethod" :SuccessGo="SuccessGo" SuccessBtnText="Сохранить" />
    </card>
  </div>
</template>

<script>
import ReFormPrinter from '../our_components/FormPrinter/ReFormPrinter.vue';


export default {
  name: 'SitesEditor',
  components:{
    ReFormPrinter,
  },
  data() {
    return {
      masAllFormParams: [],
      bIsLoading: true,
    };
  },
  computed:{
    canEdit(){
        return this.$GVO.my_profile.adm
    },
    id(){
        return this.$route.params.id||0;
    }
  },
  methods: {
    currentFormConfig() {
        this.bIsLoading = true;
        this.$GVO.ApiCall('marketing_sites.GET_FORM_MODEL',{flt:{'result_id': this.id}})
            .then((objApi) => {
                if(objApi.success){
                    this.masAllFormParams = objApi.config;
                }
                this.bIsLoading = false;
            })
            .catch(errorObjApi => console.error(errorObjApi));
        return [];
    },		
    currentApiFormMethodComp(){
        return {apiMethod:'marketing_sites.INSUPD',apiParam:{iData:[],flt:{'id': this.id}}};
    },
    SuccessGo(evt,dopParam){
        // console.log('dop',dopParam);
        if(dopParam.new_id>''){
            this.$router.replace({path: dopParam.new_id+'/terms'});
        }else{
            this.$router.back();
        }
    },
    GoAccessEdit(path,row){
        if(row.id != null){
            this.$router.push({path: `/data/sites/${row.id}`});
        }
    },
    Return(){
        this.$router.push({path: '/data/sites/'});
    },    
  },
  mounted() {
    this.currentFormConfig();
	  this.currentApiFormMethod = this.currentApiFormMethodComp();
  }
};
</script>

<style scoped>

</style>